// Browser SDK. Picked up automatically by the `sentry()` Astro integration,
// which looks for `sentry.client.config.(ts|js)` at the project root and injects
// it into every page (see astro.config.mjs).
//
// Errors only. This is a content site: there is no performance budget to spend
// on tracing spans, and Session Replay is deliberately never enabled — it
// records the reader's screen, which is far more than error tracking needs.
import * as Sentry from "@sentry/astro";
import {
  SENTRY_DATA_COLLECTION,
  SENTRY_DSN,
  resolveSentryEnvironment,
} from "./src/lib/sentry";

// The new site has no committed DSN. Keep the browser SDK inert until the
// Proseafarers Sentry project supplies PUBLIC_SENTRY_DSN.
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: resolveSentryEnvironment(
      import.meta.env.PUBLIC_SENTRY_ENVIRONMENT,
    ),

    // Errors only — no tracing, no spans.
    tracesSampleRate: 0,

    // Session Replay stays off. Both rates are pinned at 0 so enabling it can
    // only ever be a deliberate edit, never an upgrade default.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,

    // Keep reader identity, cookies and IP addresses out of events.
    dataCollection: SENTRY_DATA_COLLECTION,

    initialScope: { tags: { app: "blog-proseafarers" } },
  });
}
